<template>
    <div class="icons-loader">
        <div class="no-freeze-spinner">
            <div class="loader-items" :class="size">
                <i class="icon-man-accout"></i>
                <i class="icon-time"></i>
                <i class="icon-Credit-card"></i>
                <i class="icon-services"></i>
                <i class="icon-scheduling"></i>
                <div class="loader-circle"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IconsLoader',
    props: {
      size: {
        type: String,
        default: 'sm'
      }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_i18n-mixins.scss";

.icons-loader {
  width: 100%;
  height: 100%;
  position: relative;

  $checklist_loader_color: #21afea;
  $checklist_loader_bg: rgba(33, 175, 234, 0.3);

  .no-freeze-spinner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 0.1s linear;
    z-index: 1;
    opacity: 0.5;
    transform: scale(1);

    > .loader-items {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      border-radius: 50%;
      padding: 5px;

      &.sm {
        width: 60px;
        height: 60px;
      }

      &.md {
        width: 85px;
        height: 85px;
      }
    }

    .loader-items .loader-circle {
      animation-play-state: running;
    }

    > .loader-items > .loader-circle {
      animation-play-state: paused;
      border: 5px solid $checklist_loader_color;
      border-radius: 50%;
      animation: rotate 1s infinite linear;
      border-left-color: $checklist_loader_bg;
      width: 100%;
      height: 100%;
    }

    i {
      position: absolute;
      bottom: 0;
      margin: auto;
      color: $checklist_loader_color;
      width: 24px;
      height: 24px;
      line-height: 1;
      transform: scale(0) translate3d(0, 0, 0);
    }

    .sm {
      i {
        font-size: 24px;
        top: 1px;
        @include i-position-mirror(left, 2px);
        @include i-position-mirror(right, 0);
      }
    }

    .md {
      i {
        font-size: 35px;
        top: -15px;
        @include i-position-mirror(left, -10px);
        @include i-position-mirror(right, 0);
      }
    }

    i:nth-of-type(1) {
      animation: loadicons 5s infinite ease-in-out;
    }
    i:nth-of-type(2) {
      animation: loadicons 5s 1s infinite ease-in-out;
    }
    i:nth-of-type(3) {
      animation: loadicons 5s 2s infinite ease-in-out;
    }
    i:nth-of-type(4) {
      animation: loadicons 5s 3s infinite ease-in-out;
    }
    i:nth-of-type(5) {
      animation: loadicons 5s 4s infinite ease-in-out;
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes loadicons {
    0% {
      transform: scale(0) translate3d(0, 0, 0);
    }
    11% {
      transform: scale(1.2) translate3d(0, 0, 0);
    }
    22% {
      transform: scale(1) translate3d(0, 0, 0);
    }
    33% {
      transform: scale(0) translate3d(0, 0, 0);
    }
  }
}
</style>